import { useContext, useEffect } from "react";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";

import { Card } from "react-bootstrap";
import useCreateAction from "../actions/create/useCreateAction";
import useListAction from "../actions/list/useListAction";
import useEditAction from "../actions/edit/useEditAction";
import useRemoveAction from "../actions/remove/useRemoveAction";
import { getTableConfig } from "../helpers/tables";
import { useLocation } from "react-router-dom";
import useDetailsAction from "../actions/details/useDetailsAction";

function TableWithDetailsPage(props: {
  modelConfig: any;
  templates?: [];
  modalSize?: string;
}) {
  const { modelConfig, templates, modalSize } = props;
  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(modelConfig, user);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(modelConfig, indexFunction);

  const { detailsFunction } = useDetailsAction(modelConfig, 0);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(modelConfig, indexFunction);

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  let tableConfig = getTableConfig(modelConfig.tableConfig, {
    indexFunction: indexFunction,
    actionsFunctions: [
      {
        name: "create",
        function: initializeFunction,
      },
    ],
    rowFunctions: [
      {
        name: "edit",
        function: detailsFunction,
      },
      {
        name: "delete",
        function: prepareRemoveFunction,
      },
    ],
  });
  setTableConfig(tableConfig);

  const location = useLocation(); // Obtener la ubicación de la URL

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search); // Obtener los parámetros de la URL
    const isNew = urlParams.get("new"); // Obtener el parámetro 'new'

    if (isNew === "true") {
      initializeFunction(); // Si el parámetro 'new' es 'true', ejecutar la función initializeFunction
    }
  }, [location]); // Dependencia en location para que se ejecute cuando la URL cambie

  return (
    <Card>
      <Card.Header className="d-flex align-items-center justify-content-between ps-3 bg-white">
        <h2 className="card-header-title">
          <span>{t(modelConfig.modelPluralName)}</span>
        </h2>
        <div>
          <BeelditTableHeaderActions
            actions={tableConfig.actions}
          ></BeelditTableHeaderActions>
        </div>
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {createActionTemplate}
        {removeActionTemplate}
        {templates &&
          templates.map((template: any, index: number) => {
            return { template };
          })}
        {/* newTemplateActions */}
      </Card.Body>
    </Card>
  );
}

export default TableWithDetailsPage;
